export default {
  hero: {
    breadcrumbs: {
      home: 'Pagina principală',
      properties: 'Proprietăți'
    }
  },
  property: {
    title: 'Titlu',
    description: 'Descriere',
    price: 'Preț',
    price_currency: 'Valută',
    gross_area: 'Suprafață totală',
    net_area: 'Suprafață utilă',
    floor: 'Etaj',
    total_floors: 'Etaje totale',
    rooms: 'Număr de camere',
    layout_type: 'Tip de compartimentare',
    status: 'Stare proprietate',
    purpose: 'Destinație',
    ownership: 'Drept de proprietate',
    heating: 'Tip de încălzire',
    orientation: 'Orientare',
    view: 'Vedere',
    address: 'Adresă',
    year_of_construction: 'Anul construcției',
    location: 'Locație',
    video: 'Prezentare video',
    features: 'Caracteristici',
    contact_agent: 'Contactează agentul',
    request_price: 'Solicită prețul actual',
    back_to_all: '← Înapoi la toate proprietățile',
    developer: 'Dezvoltator',
    residential_complex: 'Complex rezidențial',
    building: 'Clădire',
    ai_prediction: 'Evaluare AI',
    evaluation_chart: 'Grafic evaluare',
    map: 'Hartă',
    gallery: 'Galerie',
    video_tour: 'Tur video',
    loading: 'Se încarcă datele apartamentului...',
    catalog_id: 'Număr în catalog',
    layout_type_label: 'Tip proprietate',
    status_label: 'Stare',
    purpose_label: 'Destinație',
    heating_label: 'Încălzire',
    orientation_label: 'Orientare',
    building_type_label: 'Tip clădire',
    view_label: 'Vedere',
    citizenship_available: 'Eligibil pentru cetățenie',
    mortgage_available: 'Ipotecă disponibilă',
    not_specified: 'Nespecificat',

    // Din PropertyCharacteristics
    country: 'Țară',
    region: 'Regiune',
    city: 'Oraș',
    district: 'Cartier',
    residential_complex_label: 'Complex rezidențial',
    building_label: 'Clădire',
    rooms_label: 'Număr de camere',
    floor_label: 'Etaj',
    total_floors_label: 'Etaje în clădire',
    gross_area_label: 'Suprafață totală',
    net_area_label: 'Suprafață utilă',
    year_of_construction_label: 'Anul construcției',
    heating_label_fallback: 'Încălzire',
    orientation_label_fallback: 'Orientare',
    building_type_label_fallback: 'Tip clădire',
    view_label_fallback: 'Vedere',

    gallery_title: 'Fotografii proprietate',

    agent: {
      full_name: 'Agent',
      agency: 'Agenție',
      phone: 'Telefon'
    },

    amenities: {
      title: 'Facilități',
      empty: 'Nu sunt specificate facilități'
    },

    characteristics: {
      title: 'Caracteristici',
      loading: 'Se încarcă caracteristicile...'
    },

    video: {
      no_video: 'Video indisponibil'
    },

    unpublished: {
      title: '🏗️ Proprietatea nu este publicată',
      message: 'Apartamentul nu este disponibil pentru vizualizare publică.',
      location: 'Locație',
      home: 'Pagina principală'
    }
  }
}
